'use client'

import { cn } from '@/lib/utils'
import { CrmProviderLogo } from './crm-provider-logo'
import type { CrmProviderInfo } from '@/hooks/integrations/use-crm-integrations'
import { useTranslations } from "next-intl"


interface CrmProviderCardProps {
  provider: CrmProviderInfo
  onClick: () => void
  disabled?: boolean
}

/**
 * Clickable card for a CRM provider.
 * Shows provider logo, name, and coming soon badge if not implemented.
 */
export function CrmProviderCard({ provider, onClick, disabled }: CrmProviderCardProps) {
  const tUi = useTranslations("Crm.CrmCrmProviderCard")

  const isDisabled = disabled || !provider.implemented

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        'flex flex-col items-center gap-2 p-4 rounded-lg border transition-all',
        'min-w-[120px] text-center',
        isDisabled
          ? 'bg-gray-50 border-gray-200 cursor-not-allowed opacity-60'
          : 'bg-white border-gray-200 hover:border-blue-300 hover:bg-blue-50 cursor-pointer hover:shadow-sm',
      )}
    >
      <div
        className="p-4 rounded-full"
        style={{ backgroundColor: `${provider.color}15` }}
      >
        <CrmProviderLogo
          provider={provider.id}
          logoUrl={provider.logoUrl}
          size={48}
        />
      </div>
      <div className="flex flex-col items-center gap-1">
        <span className="font-medium text-sm text-gray-900">{provider.name}</span>
        {!provider.implemented && (
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
            <span key={tUi("comingSoon")}>{tUi("comingSoon")}</span></span>
        )}
      </div>
    </button>
  )
}
